/* layers.svelte.ts generated by Svelte v5.55.4 */
import * as $ from 'svelte/internal/client';

class LayerStore {
	#layers = $.state($.proxy([]));

	get layers() {
		return $.get(this.#layers);
	}

	set layers(value) {
		$.set(this.#layers, value, true);
	}

	register(id, label, layer, map) {
		this.layers.push({ id, label, layer, map, active: false });
	}

	toggle(id) {
		const entry = this.layers.find((l) => l.id === id);

		if (!entry) return;

		if (entry.active) {
			entry.layer.remove();
			entry.active = false;
		} else {
			entry.layer.addTo(entry.map);
			entry.active = true;
		}
	}

	isActive(id) {
		return this.layers.find((l) => l.id === id)?.active ?? false;
	}
}

export const layerStore = new LayerStore();